module.exports = __webpack_public_path__ + "aa4c14e77a2a7086691bec6af01f8b8d.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 45
// module chunks = 0